import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '首页', icon: 'dashboard' }
    }]
  },
  {
    path: '/exercise',
    component: Layout,
    redirect: '/exercise/knowledgeList',
    name: 'exercise',
    meta: { title: '对练机器人', icon: 'el-icon-s-help' },
    children: [
      {
        path: 'knowledgeList',
        name: 'knowledgeList',
        component: () => import('@/views/exercise/knowledge/list'),
        meta: { title: '知识列表', icon: 'table' }
      },
      {
        path: 'uploadKnowledge',
        name: 'uploadKnowledge',
        component: () => import('@/views/exercise/uploadKnowledge'),
        meta: { title: '知识管理', icon: 'form', isHidden: true }
      },
      {
        path: 'taskBaseList',
        name: 'taskBaseList',
        component: () => import('@/views/exercise/taskBase/list'),
        meta: { title: '任务资源库', icon: 'table' }
      },
      {
        path: 'storyList',
        name: 'storyList',
        component: () => import('@/views/exercise/list/storyList'),
        meta: { title: '故事列表', icon: 'table' }
      },
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/exercise/list/index'),
        meta: { title: '机器人列表', icon: 'table' }
      },
      {
        path: 'updateExercise',
        name: 'updateExercise',
        component: () => import('@/views/exercise/list/update'),
        meta: { title: '编辑机器人', icon: 'form', isHidden: true }
      },
      {
        path: 'addStory',
        name: 'addStory',
        component: () => import('@/views/exercise/list/addStory'),
        meta: { title: '新增故事', icon: 'form', isHidden: true }
      },
      {
        path: 'updateStory',
        name: 'updateStory',
        component: () => import('@/views/exercise/list/updateStory'),
        meta: { title: '编辑故事', parent: 'addStory', icon: 'form', isHidden: true }
      },
      {
        path: 'taskBaseDetail',
        name: 'taskBaseDetail',
        component: () => import('@/views/exercise/taskBase/detail'),
        meta: { title: '步骤详情', icon: 'form', isHidden: true }
      },
      {
        path: 'addStoryItem',
        name: 'addStoryItem',
        component: () => import('@/views/exercise/list/storyAdd'),
        meta: { title: '新增/编辑', icon: 'form', isHidden: true }
      }
      // {
      //   path: 'addCustomer',
      //   name: 'AddCustomer',
      //   component: () => import('@/views/exercise/list/add'),
      //   meta: { title: 'addCustomer', icon: 'form' }
      // }
    ]
  },
  // {
  //   path: '/knowledge',
  //   component: Layout,
  //   redirect: '/knowledge/list',
  //   meta: { title: '知识库管理', icon: 'el-icon-s-help' },
  //   children: [
  //     {
  //       path: 'list',
  //       name: '/knowledge/list',
  //       component: () => import('@/views/knowledge/list'),
  //       meta: { title: '知识库列表', icon: 'table' }
  //     },
  //     {
  //       path: 'edit',
  //       name: '/knowledge/edit',
  //       component: () => import('@/views/knowledge/edit'),
  //       meta: { title: '添加/编辑知识库', icon: 'form', isHidden: true }
  //     },
  //     {
  //       path: 'import',
  //       name: '/knowledge/import',
  //       component: () => import('@/views/knowledge/import'),
  //       meta: { title: '导入知识', icon: 'table', isHidden: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/example',
  //   component: Layout,
  //   redirect: '/example/table',
  //   name: 'Example',
  //   meta: { title: 'Example', icon: 'el-icon-s-help' },
  //   children: [
  //     {
  //       path: 'table',
  //       name: 'Table',
  //       component: () => import('@/views/table/index'),
  //       meta: { title: 'Table', icon: 'table' }
  //     },
  //     {
  //       path: 'tree',
  //       name: 'Tree',
  //       component: () => import('@/views/tree/index'),
  //       meta: { title: 'Tree', icon: 'tree' }
  //     }
  //   ]
  // },

  // {
  //   path: '/form',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'Form',
  //       component: () => import('@/views/form/index'),
  //       meta: { title: 'Form', icon: 'form' }
  //     }
  //   ]
  // },

  // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1',
  //   name: 'Nested',
  //   meta: {
  //     title: 'Nested',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'Menu1',
  //       meta: { title: 'Menu1' },
  //       children: [
  //         {
  //           path: 'menu1-1',
  //           component: () => import('@/views/nested/menu1/menu1-1'),
  //           name: 'Menu1-1',
  //           meta: { title: 'Menu1-1' }
  //         },
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'Menu1-2',
  //           meta: { title: 'Menu1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'Menu1-2-1',
  //               meta: { title: 'Menu1-2-1' }
  //             },
  //             {
  //               path: 'menu1-2-2',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  //               name: 'Menu1-2-2',
  //               meta: { title: 'Menu1-2-2' }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-3',
  //           component: () => import('@/views/nested/menu1/menu1-3'),
  //           name: 'Menu1-3',
  //           meta: { title: 'Menu1-3' }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       name: 'Menu2',
  //       meta: { title: 'menu2' }
  //     }
  //   ]
  // },

  // {
  //   path: 'external-link',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'https://panjiachen.github.io/vue-element-admin-site/#/',
  //       meta: { title: 'External Link', icon: 'link' }
  //     }
  //   ]
  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
